export const arraysEqual = (array1: string[]) => (array2: string[]) => JSON.stringify(array1) === JSON.stringify(array2);
